import { useCallback } from "react";
import { CardService } from "services";
import CardList from "./list";

const CardCrmList = () => {

  const fetch = useCallback((page: number, search: string | undefined) => CardService.cardsAll({ page: page ?? 0, search: search, crm: true }), []);

  return <CardList fetch={fetch} />;
}

export default CardCrmList;